module.exports = __webpack_public_path__ + "static/media/parties.72b3bace.svg";